import { CanActivateFn, Router } from "@angular/router";
import { inject } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from "@angular/router";
import { Observable } from "rxjs";
import { UserRepository } from "@services/user.repository.service";
import { AppStore } from "@services/store/app.store";

export const authGuard: CanActivateFn = (): boolean => {
  const router = inject(Router);
  const appStore = inject(AppStore);
  
  if (appStore.isAuthenticated()) {
    return true;
  }

  router.navigate(['/login'], { replaceUrl: true });
  return false;
};

export function canActivate(
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
  const userRepository = inject(UserRepository);
  const router = inject(Router);

  const currentUser = userRepository.getUser();

  if (currentUser && currentUser.isAuthenticated()) {
    router.navigate(['/app/utente'], { replaceUrl: true });
    return false;
  }

  return true;
} 